import React from 'react';
import type {
  EventDetailsVm,
  ReportDetailsVm,
} from 'src/components/pages/Case/Case.slice';
import type { ReportType } from 'src/graphql';
import { EventDetailsAccordion } from '../../../EventDetailsAccordion';

interface ReportEventsContainerProps
  extends
    Omit<React.HTMLAttributes<HTMLDivElement>, 'children'>,
    Pick<Partial<ReportDetailsVm>, 'events'> {
  'data-testid'?: string;
  report: ReportType;
  testVm?: EventDetailsVm;
}

export const ReportEventsContainer = ({
  events,
  report,
  testVm,
  ...props
}: ReportEventsContainerProps) => {
  return (
    <div
      {...props}
      data-testid={props['data-testid'] ?? 'new-case-report-events-container'}
    >
      {events?.map((event, index) => {
        const isFirstEvent = index === 0;
        const isLastEvent = index === events.length - 1;
        return (
          <EventDetailsAccordion
            testVm={testVm}
            isFirstEvent={isFirstEvent}
            isLastEvent={isLastEvent}
            key={event.id}
            data-testid={`case-report-event-${index}`}
            defaultOpen={isLastEvent && events.length > 1}
            eventId={event.id}
            reportId={report?.id ?? ''}
            last={isLastEvent}
            isDominantLanguageKnown={report.dominantLanguage !== 'unknown'}
          />
        );
      })}
    </div>
  );
};
